module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8jGZ1"))).then(() => parcelRequire('2KbAe'));